import styled from '@emotion/styled'
import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'next-i18next'
import {
  BackButton,
  BottomSection,
  Button,
  CourseAmountButton,
  TitleSection,
} from '../../styled.components'
import { motion } from 'framer-motion'

type Props = {
  setCurrentStep: Dispatch<
    SetStateAction<
      'stepone' | 'steptwo' | 'stepthree' | 'stepfour' | 'stepfive'
    >
  >
  setStudentAudience: Dispatch<
    SetStateAction<'lessThen5000' | 'moreThen5000' | 'moreThen20000'>
  >
  studentAudience: 'lessThen5000' | 'moreThen5000' | 'moreThen20000'
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3.5rem;
  max-width: 340px;
  margin: 2rem auto;
  margin-top: 0rem;
`

const OptionsSelection = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

const StepTwo = ({
  setCurrentStep,
  setStudentAudience,
  studentAudience,
}: Props) => {
  const { t } = useTranslation(['landingPage'])
  const handleChangeAudience = (
    value: 'lessThen5000' | 'moreThen5000' | 'moreThen20000'
  ) => {
    setStudentAudience(value)
  }
  return (
    <motion.div
      initial={{ opacity: 0, translateY: 100 }}
      animate={{
        opacity: 1,
        translateY: 0,
      }}
      transition={{
        duration: 0.3,
      }}
    >
      <Container>
        <TitleSection>{t('connectWithUs.stepTwo.title')}</TitleSection>
        <OptionsSelection>
          <CourseAmountButton
            width="11.5rem"
            onClick={() => handleChangeAudience('lessThen5000')}
            active={studentAudience === 'lessThen5000'}
          >
            {t('connectWithUs.stepTwo.options.lessThen5000')}
          </CourseAmountButton>
          <CourseAmountButton
            width="11.5rem"
            onClick={() => handleChangeAudience('moreThen5000')}
            active={studentAudience === 'moreThen5000'}
          >
            {t('connectWithUs.stepTwo.options.moreThen5000')}
          </CourseAmountButton>
          <CourseAmountButton
            width="11.5rem"
            onClick={() => handleChangeAudience('moreThen20000')}
            active={studentAudience === 'moreThen20000'}
          >
            {t('connectWithUs.stepTwo.options.moreThen20000')}
          </CourseAmountButton>
        </OptionsSelection>
        <BottomSection>
          <BackButton onClick={() => setCurrentStep('stepone')}>
            {t('connectWithUs.stepTwo.goBack')}
          </BackButton>
          <Button onClick={() => setCurrentStep('stepthree')}>
            {t('connectWithUs.stepTwo.nextStep')}
          </Button>
        </BottomSection>
      </Container>
    </motion.div>
  )
}

export default StepTwo
